var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isImage)?_c('img',_vm._b({attrs:{"src":_vm.imageContent}},'img',_vm.$attrs,false)):_c('embed',_vm._b({attrs:{"src":_vm.imageContent,"type":_vm.imageType}},'embed',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }